import gql from "graphql-tag";

export const portalNotificationFieldsFragment = gql`
    fragment portalNotificationFields on PortalNotification {
        id,
        name,
        linkName,
        linkPath

    }
    `